// Libs
import React, { ReactElement } from 'react';
// App
import styles from 'app-shared/lib/layout/shared/header/header.module.scss';

import MainNav from './main-nav';
import Brand from 'app-shared/lib/layout/shared/header/brand';
import { Gutter } from 'app-shared/lib/layout/shared/gutter';

const Header = (props: { showMainNav?: boolean }): ReactElement => {
  const { showMainNav = true } = props;

  return (
    <header className={styles.header}>
      <Gutter className={styles.gutter}>
        <Brand className={styles.brand} />
        {showMainNav && <MainNav />}
      </Gutter>
    </header>
  );
};

export default Header;
